import { gql } from '@apollo/client';

export const VATFINANCING_DATA_QUERY = gql`
  query vatFinancingDocument($documentId: Int!, $siteId: Int!) {
    vatFinancingDocument(documentId: $documentId, siteId: $siteId) {
      amount
      documentId
      durationMonths
      maxDurationMonths
      minDurationMonths
      graceMonths
      interestPercent
      siteId
    }
}`;
